export const getMuiBootstrapFormControlSX = (styles: {
    rootStyle?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
    iconStyle?: React.CSSProperties;
    outlineStyle?: React.CSSProperties;
}) => ({
    ".MuiInputBase-root": {
        ...styles.rootStyle,
        padding: 0,
    },
    ".MuiInputBase-input": {
        background: "#f5f5f5",
        border: "1px solid #eaeaea",
        boxSizing: "border-box",
        borderRadius: "4px",

        display: "block",
        width: "100%",
        height: "calc(1.5em + 0.75rem + 2px)",
        padding: "0.375rem 0.75rem",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5",
        color: "#495057",
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        "&:focus": {
            borderColor: "#80bdff",
        },
        ...styles.inputStyle,
    },
    ".MuiOutlinedInput-notchedOutline": {
        ...styles.outlineStyle,
    },
    ".MuiIconButton-edgeEnd": {
        ...styles.iconStyle,
    },
});
